import { Button, Stack, styled } from "prism-react";

export const StyledToggleButton = styled(Button, {
  [`&[data-active="true"]`]: {
    background: "$neutral-bg-focus",
  },
});

export const StyledContainer = styled(Stack, {
  height: "100%",
  overflow: "auto",
  position: "relative",
  fontFamily: "$mono",
});
